import React, {FunctionComponent, useState} from 'react'
import GoogleMapReact from 'google-map-react';
import {GarageMapMarker} from "@App/Components/GarageMapMarker";
import {Garage, Service} from "@App/types";
import {FilterSquare} from "@App/Components/FilterSquare";
import {MapIcon, MapLocationIcon} from "@App/Components/common/Icons";

type GarageMapProps = {
    center: {
        lat: number,
        lng: number,
    },
    zoom: number,
    garages: Garage[],
    service: Service,
    className?: String,
    style?: Object,
    onClose?: () => void,
    onSelectGarage: (garage: Garage) => void
}

type GarageMapState = {
    selectedGarage?: Garage
}

export const GarageMap: FunctionComponent<GarageMapProps> = (props: GarageMapProps)  => {

    const [selectedGarage, setSelectedGarage] = useState(null)

    const selectMarker = (garage: Garage, open: boolean) => {
        if (open) {
            setSelectedGarage(garage)
            return
        }
        setSelectedGarage(null)
    }

    return (
            <div id={'garage-map'} className={`${props.className}`} style={props.style}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: "AIzaSyCyOdtBEoG0atpfWsNR1VRMZPEgib8MVzY" }}
                    defaultCenter={props.center}
                    defaultZoom={props.zoom}>
                    <MapLocationIcon lat={props.center.lat} lng={props.center.lng} />
                    {props.garages.map((garage) => (
                        <GarageMapMarker
                            key={garage.id}
                            garage={garage}
                            service={props.service}
                            lat={garage.lat}
                            lng={garage.lon}
                            open={selectedGarage ? selectedGarage.id === garage.id : false}
                            onToggle={selectMarker}
                            onClick={props.onSelectGarage}
                        />
                    ))}
                </GoogleMapReact>
                <div className={'md:hidden fixed top-20 left-1'}>
                    <FilterSquare title="Listenansicht" onClick={props.onClose}>
                        <MapIcon/>
                    </FilterSquare>
                </div>
            </div>
    )
}
